import { decode } from "html-entities";

import { toTitleCase } from "@/utils/titleCase";

export function formatHotelName(name: string): string {
  const trimmed = name?.trim();
  if (!trimmed) return "";

  return toTitleCase(decode(trimmed));
}

export function formatRoomName(name: string): string {
  const trimmed = name?.trim();
  if (!trimmed) return "";

  // common typos
  const fixedTypos = trimmed
    .replace(/\bROOK\b/gi, "ROOM")
    .replace(/\bRESRT\b/gi, "RESORT")
    .trim();

  return toTitleCase(fixedTypos);
}
